import React from 'react';
import PropTypes from 'prop-types';

import Card from '../../common/Card';

const SettingsAside = ({ content }) => {
	return (
		<div className="settings__aside">
			<Card>
				<h2 dangerouslySetInnerHTML={{__html: content.title}}></h2>
				<p>{content.message}</p></Card>
		</div>
	);
};

SettingsAside.propTypes = {
	content: PropTypes.shape({
		title: PropTypes.string.isRequired,
		message: PropTypes.string.isRequired,
	}).isRequired,
}

export default SettingsAside;


// WEBPACK FOOTER //
// ./src/components/routes/Settings/SettingsAside.js